var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"10","height":"10","viewBox":"0 0 10 10","fill":"none","stroke":"#98a2b3","stroke-width":"1.5","stroke-linecap":"round","aria-hidden":"true"}},[_c('path',{attrs:{"d":"m2.5 2.5 5 5M7.5 2.5l-5 5"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }